import React from 'react';

import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';

import ResourceTooltip from '@src/components/common/Display/ResourceTooltip';
import {
    getNameMonthDayYear,
    getHourAndMinutesByDate,
} from '@src/services';

import '@src/css/bootstrap.scss';

import './upcomingLiveTraining.scss';

const pickChannel = (channel) => {
    if (channel === 'both') {
        return 'IA / PCS';
    }

    if (!channel) {
        return '';
    }

    return channel.toUpperCase();
};

export const UpcomingLiveTraining = (props) => {
    const {
        title = '',
        date,
        content = '',
        link = {
            text: '',
            link: '',
        },
        agents = '',
        states = [],
        products = [],
        publishedAt,
    } = props;

    return (

        <Card className="upcoming-live-training-container text-center">
            <div className="upcoming-live-training-title-container">
                <h3>Upcoming Event</h3>
                <img src="/img/upcoming_event.png" />
                <a className="link-primary" href={`training-and-job-aids/webinars/${link.link}`}>{title}</a>
                <div className="upcoming-live-training-date-container">
                    {
                        date
                            ? (
                                <>
                                    <div>{getNameMonthDayYear(date)}</div>
                                    {
                                        getHourAndMinutesByDate(date) !== ''
                                    && <div className="upcoming-live-training-date-spacer"> | </div>
                                    }
                                    <div>{getHourAndMinutesByDate(date)}</div>
                                </>
                            )
                            : <div>Dates and times will vary</div>
                    }
                </div>

                <div className="upcoming-live-training-content">
                    {content}
                </div>
                <div className="GeneralPromoCard_link_tooltip_container">
                    <ResourceTooltip
                        placement="left"
                        agents={pickChannel(agents)}
                        states={states}
                        products={products}
                        publishedAt={publishedAt}
                    />
                </div>
            </div>
        </Card>
    );
};

UpcomingLiveTraining.propTypes = {
    title: PropTypes.string,
    date: PropTypes.string,
    content: PropTypes.string,
    link: PropTypes.shape({
        text: PropTypes.string,
        link: PropTypes.string,
    }),
    agents: PropTypes.string,
    states: PropTypes.array,
    products: PropTypes.array,
    publishedAt: PropTypes.string,
};

export default UpcomingLiveTraining;
